import { ChangeDetectorRef, inject, ViewContainerRef } from '@angular/core';
import { LayoutService } from '@modules/core/services';
import { pathDirLayout, layoutComponentName } from '@modules/core/types';

/**
 * Abstract class representing a Layout.
 * This class provides a method to inject a layout component into a specified container.
 */
export abstract class Layout {
  /**
   * Abstract property representing a ViewContainerRef.
   * This property should be overridden in subclasses to provide the container where the layout component will be injected.
   */
  abstract containerRef: ViewContainerRef;

  /**
   * Property representing a ChangeDetectorRef.
   * This property is used to detect changes in the component.
   */
  ref: ChangeDetectorRef = inject(ChangeDetectorRef);

  /**
   * Property representing a LayoutService.
   * This service is used to inject the layout component.
   */
  layoutService: LayoutService = inject(LayoutService);

  /**
   * Method to inject a layout component into the containerRef.
   *
   * @param {layoutComponentName} layoutComponentName - The name of the layout component to be injected.
   * @param {pathDirLayout} componentLayoutDir - The directory path of the layout component.
   */
  protected injectLayout(layoutComponentName: layoutComponentName, componentLayoutDir: pathDirLayout): void {
    this.layoutService.injectLayout(this.containerRef, this.ref, layoutComponentName, componentLayoutDir).subscribe();
  }
}
